import { Card, Button, Loading } from '@geist-ui/react'
import { useGoogleApi } from 'react-gapi'
import { useState } from 'react'
import Layout from './layout'

const Home = () => {
  const googleGApi = useGoogleApi()
  const [auth, setAuth] = useState<any | null>(null)

  if (googleGApi && !googleGApi.auth2) {
    googleGApi.load('auth2', () => {
      googleGApi.auth2.init({
        clientId: '524758991649-us5crbpm6el3jkc51e4d5nh7mq1frkp3.apps.googleusercontent.com',
        ux_mode: 'redirect',
      })
      setAuth(googleGApi?.auth2.getAuthInstance())
    })
  }

  if (!auth)
    return (
      <Layout>
        <Loading />
      </Layout>
    )

  if (auth?.isSignedIn?.get())
    return (
      <Layout>
        <p>Welcome user {auth.currentUser.get().getBasicProfile().getName()}</p>
        <Button onClick={() => auth?.signOut()}>Sign Out</Button>
      </Layout>
    )
  return (
    <Layout>
      <Button
        onClick={() => {
          console.log('signin', auth)
          auth.signIn()
        }}>
        Login
      </Button>
    </Layout>
  )
}

export default Home
